import React from 'react';
import { render } from '@testing-library/react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CandidateIcon from '../CandidateIcon';

const theme = createTheme();

const renderWithProviders = (component: React.ReactElement) => {
  return render(<ThemeProvider theme={theme}>{component}</ThemeProvider>);
};

describe('CandidateIcon', () => {
  it('renders icon for existing candidate', () => {
    const { container } = renderWithProviders(<CandidateIcon existingCandidate={true} />);

    const svg = container.querySelector('svg');
    expect(svg).toBeInTheDocument();
  });

  it('renders icon for new candidate', () => {
    const { container } = renderWithProviders(<CandidateIcon existingCandidate={false} />);

    const svg = container.querySelector('svg');
    expect(svg).toBeInTheDocument();
  });

  it('renders icon with custom sx styles', () => {
    const { container } = renderWithProviders(
      <CandidateIcon existingCandidate={true} sx={{ fontSize: '2rem' }} />
    );

    const svg = container.querySelector('svg');
    expect(svg).toBeInTheDocument();
  });
});
